import styled from "styled-components"
import { Link } from "gatsby"
import {
  CursorCrosshairWhite,
  CursorCrosshairBlack,
} from "shared/Styles/Cursors"

export const LogoWrapper = styled(Link)`
  ${props =>
    (props.light && !props.active ? CursorCrosshairBlack : CursorCrosshairWhite)}
  position: fixed;
  left: 50%;
  top: 40px;
  width: 225px;
  transform: translate(-50%, 0);
  z-index: 5;
`
